import type { RSheetColumn, RSheetRecordNode } from '../../domain/column'
import { getRecordNodeWithInnerRowIndex } from './innerRowRelated'

export const getCellRelated = (
  column: RSheetColumn<RSheetRecordNode>,
  row: RSheetRecordNode,
  innerRowIndex: number,
): {
  recordNode: RSheetRecordNode | undefined
  value: unknown
  isBlankFillerCell: boolean
} => {
  const recordNodeWithInnerRowIndex = getRecordNodeWithInnerRowIndex(row, column.node, innerRowIndex)
  const recordNode = recordNodeWithInnerRowIndex?.recordNode
  const isBlankFillerCell =
    recordNode === undefined && recordNodeWithInnerRowIndex?.parentRecordNode === undefined
  const value = recordNode === undefined ? undefined : column.value(recordNode)

  return {
    recordNode,
    value,
    isBlankFillerCell,
  }
}
